import React, { useState } from "react";
import { Card, Button, Modal } from "react-bootstrap";
import { SiNestjs, SiMysql, SiFlutter, SiBootstrap, SiReact, SiHtml5, SiCss3, SiFirebase, SiFlask, SiNumpy, SiPython, SiPytorch, SiSpring, SiAngular, SiDocker, SiRedis, SiElasticsearch, SiHibernate, SiMongodb, SiSpringboot } from "react-icons/si";
import { FaJava } from "react-icons/fa";
import styles from "./ProjectCard.module.css";

const techUrls = {
  Angular: "https://angular.io/",
  Bootstrap: "https://getbootstrap.com/",
  CSS: "https://www.w3.org/Style/CSS/",
  Docker: "https://www.docker.com/",
  ElasticSearch: "https://www.elastic.co/elasticsearch/",
  Firebase: "https://firebase.google.com/",
  Flask: "https://flask.palletsprojects.com/",
  Flutter: "https://flutter.dev/",
  Hibernate: "https://hibernate.org/",
  HTML: "https://www.w3.org/html/",
  Java: "https://www.oracle.com/java/",
  Microservices: "https://microservices.io/",
  MongoDB: "https://www.mongodb.com/",
  MySQL: "https://www.mysql.com/",
  NestJS: "https://nestjs.com/",
  NumPy: "https://numpy.org/",
  Python: "https://www.python.org/",
  PyTorch: "https://pytorch.org/",
  RabbitMQ: "https://www.rabbitmq.com/",
  React: "https://react.dev/",
  Redis: "https://redis.io/",
  RESTful: "https://restfulapi.net/",
  Spring: "https://spring.io/",
  "Spring Cloud": "https://spring.io/projects/spring-cloud",
  "Spring MVC": "https://spring.io/guides/gs/serving-web-content/",
  "Spring Security": "https://spring.io/projects/spring-security",
  SpringBoot: "https://spring.io/projects/spring-boot",
  WebSocket: "https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API",
};

const icons = {
  Angular: <SiAngular className={styles.techIcon} style={{ color: "#DD0031" }} />,
  Bootstrap: (
    <SiBootstrap className={styles.techIcon} style={{ color: "#7952B3" }} />
  ),
  CSS: <SiCss3 className={styles.techIcon} style={{ color: "#1572B6" }} />,
  Docker: <SiDocker className={styles.techIcon} style={{ color: "#2496ED" }} />,
  ElasticSearch: <SiElasticsearch className={styles.techIcon} style={{ color: "#005571" }} />,
  Firebase: (
    <SiFirebase className={styles.techIcon} style={{ color: "#FFCA28" }} />
  ),
  Flask: (
    <SiFlask className={styles.techIcon} style={{ color: "#000000" }} />
  ),
  Flutter: (
    <SiFlutter className={styles.techIcon} style={{ color: "#02569B" }} />
  ),
  Hibernate: <SiHibernate className={styles.techIcon} style={{ color: "#59666C" }} />,
  HTML: <SiHtml5 className={styles.techIcon} style={{ color: "#E34F26" }} />,
  Java: <FaJava className={styles.techIcon} style={{ color: "#ED8B00" }} />,
  Microservices: <SiSpring className={styles.techIcon} style={{ color: "#6DB33F" }} />,
  MongoDB: <SiMongodb className={styles.techIcon} style={{ color: "#47A248" }} />,
  MySQL: <SiMysql className={styles.techIcon} style={{ color: "#4479A1" }} />,
  NestJS: <SiNestjs className={styles.techIcon} style={{ color: "#E0234E" }} />,
  NumPy: <SiNumpy className={styles.techIcon} style={{ color: "#013243" }} />,
  Python: <SiPython className={styles.techIcon} style={{ color: "#3776AB" }} />,
  PyTorch: <SiPytorch className={styles.techIcon} style={{ color: "#EE4C2C" }} />,
  RabbitMQ: <span className={styles.techIcon} style={{ color: "#FF6600", fontWeight: "bold", fontSize: "1rem" }}>🐰</span>,
  React: <SiReact className={styles.techIcon} style={{ color: "#61DAFB" }} />,
  Redis: <SiRedis className={styles.techIcon} style={{ color: "#DC382D" }} />,
  RESTful: <span className={styles.techIcon} style={{ color: "#25D366", fontWeight: "bold", fontSize: "0.8rem" }}>REST</span>,
  Spring: <SiSpring className={styles.techIcon} style={{ color: "#6DB33F" }} />,
  "Spring Cloud": <SiSpring className={styles.techIcon} style={{ color: "#6DB33F" }} />,
  "Spring MVC": <SiSpring className={styles.techIcon} style={{ color: "#6DB33F" }} />,
  "Spring Security": <SiSpring className={styles.techIcon} style={{ color: "#6DB33F" }} />,
  SpringBoot: <SiSpringboot className={styles.techIcon} style={{ color: "#6DB33F" }} />,
  WebSocket: <span className={styles.techIcon} style={{ color: "#007ACC", fontWeight: "bold", fontSize: "0.8rem" }}>WS</span>,
};

const ProjectCard = (props) => {
  const [showModal, setShowModal] = useState(false);

  // Map shadow colors
  const shadowClass = props.colorVariant === "yellow" ? styles.shadowYellow : 
                     props.colorVariant === "purple" ? styles.shadowPurple : 
                     props.colorVariant === "cyan" ? styles.shadowCyan : "";

  return (
    <>
      <Card className={`${styles.container} ${shadowClass}`}>
        <Card.Body className={styles.cardBody}>
          <Card.Title className={styles.cardTitle}>{props.title}</Card.Title>
          <Card.Text className={styles.cardText}>
            {props.content.substring(0, 200)}...
          </Card.Text>
          
          <div className={styles.techStackContainer}>
            {props.techStack.map((tech, index) => (
              <a
                key={index}
                href={techUrls[tech]}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.techIconLink}
                title={`Learn more about ${tech}`}
              >
                <span className={styles.techIcon}>
                  {icons[tech]}
                </span>
              </a>
            ))}
          </div>

          <div className={styles.buttonContainer}>
            <Button
              className={styles.button}
              onClick={() => setShowModal(true)}
            >
              Project Details
            </Button>
            
            {props.liveUrl && (
              <Button
                className={styles.button}
                href={props.liveUrl}
                target="_blank"
              >
                Live Demo
              </Button>
            )}
          </div>
        </Card.Body>
      </Card>

      {/* ── Neubrutalist Modal ── */}
      <Modal 
        show={showModal} 
        onHide={() => setShowModal(false)}
        centered
        contentClassName={styles.modalContent}
      >
        <Modal.Header className={styles.modalHeader}>
          <Modal.Title className={styles.modalTitle}>{props.title}</Modal.Title>
          <button className={styles.closeButton} onClick={() => setShowModal(false)}>×</button>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <div className={styles.modalContentWrapper}>
             <h4 className={styles.sectionHeader}>Overview</h4>
             <p className={styles.modalText}>{props.content}</p>
             
             <h4 className={styles.sectionHeader}>Technology Stack</h4>
             <div className={styles.modalTechGrid}>
               {props.techStack.map((tech, i) => (
                 <div key={i} className={styles.modalTechItem}>
                   {icons[tech]}
                   <span>{tech}</span>
                 </div>
               ))}
             </div>

             <div className={styles.modalActions}>
               {props.gitHubUrl && (
                 <a href={props.gitHubUrl} target="_blank" className={styles.button}>GitHub Repo</a>
               )}
               {props.liveUrl && (
                 <a href={props.liveUrl} target="_blank" className={styles.button}>Live Link</a>
               )}
             </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProjectCard;
